import { createContext, useContext } from 'react'

export const PageActiveContext = createContext<boolean>(true)

export const PageActiveProvider = PageActiveContext.Provider

export const usePageActive = () => useContext(PageActiveContext)
